import { CloseButton, Stack, ValidationErrors, newToast } from "@compass/core";
import { SubmitButton } from "components";
import {
  Student,
  StudentListDto,
  StudentServicePartialStudent,
  StudentServiceTemplateLinkExisting,
} from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { StudentLinkTypeTab } from "./StudentLinkPageBody";

export const StudentLinkPageHeader = (props: {
  theme?: "Dark" | "Standard";
  currentTab: StudentLinkTypeTab;
  newStudent: Student | undefined;
  partialStudent: StudentServicePartialStudent;
  existingStudent: StudentListDto | undefined;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
  onSave: (id: number) => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const save = () => {
    props.setValidationErrors({});

    if (props.currentTab == "Existing Student") {
      var request: StudentServiceTemplateLinkExisting = {
        existingStudentId: props.existingStudent!.id,
        studentServicePartialStudentId: props.partialStudent.id,
      };
      ApiService.studentServiceTemplates
        .linkExistingStudent(request)
        .then((response) => {
          navigate("../");
          window.location.reload();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    } else if (props.currentTab == "New Student") {
      ApiService.students
        .saveCreate(props.newStudent!)
        .then((studentId) => {
          var request: StudentServiceTemplateLinkExisting = {
            existingStudentId: studentId,
            studentServicePartialStudentId: props.partialStudent.id,
          };
          ApiService.studentServiceTemplates
            .linkExistingStudent(request)
            .then((response) => {
              navigate("../");
              window.location.reload();
              dispatch(setAppToast(newToast("success")));
            })
            .catch((ex) => {
              dispatch(setAppToast(newToast("error")));
              props.setValidationErrors(ex.data);
            });
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    }
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        Link Student
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton theme={props.theme} confirm={props.unsavedChanges} />

        <SubmitButton
          theme={props.theme}
          onClick={() => save()}
          disabled={
            (props.currentTab == "New Student" && !props.newStudent) ||
            (props.currentTab == "Existing Student" && !props.existingStudent)
          }
        />
      </Stack>
    </Stack>
  );
};
